import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { dicomProcessorVersionState } from '~/state/atoms/dicomProcessorAtoms';

/**
 * Returns a function that signals "the DicomProcessor cache changed".
 *
 * Call it after any mutation of the processor — committing an import,
 * removing a series, removing a SOP object. The processor is mutated in
 * place and is not a tracked domain aggregate, so this is the only signal
 * consumers of `dicomProcessor.patients` have.
 *
 * See {@link dicomProcessorVersionState} for why the domain version is not
 * sufficient.
 */
export function useBumpDicomProcessorVersion(): () => void {
    const setVersion = useSetRecoilState(dicomProcessorVersionState);
    return useCallback(() => {
        setVersion((v) => v + 1);
    }, [setVersion]);
}
